import {useDevice} from 'platform/foundation';

const MOBILE_NAVIGATION_DEVICES = ['mobile', 'tablet'] as const;

export function useIsMobileNavigation() {
  const device = useDevice();

  return MOBILE_NAVIGATION_DEVICES.includes(device);
}
